var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{attrs:{"options":_vm.options},on:{"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')},"ready":function($event){return _vm.$emit('ready')},"change":_vm.onChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }